import * as React from "react";

function SvgPersonLove(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="currentColor"
      {...props}
    >
      <defs>
        <path
          id="PersonLove_svg__a"
          d="M12.459 6.506c0-.976-.807-1.771-1.787-1.76-.991.012-1.767.782-1.77 1.755-.004.984.786 1.76 1.788 1.754.995-.008 1.768-.772 1.769-1.749zM10.666 10c-1.964-.007-3.573-1.584-3.57-3.498C7.1 4.587 8.744 2.987 10.694 3c1.95.012 3.574 1.606 3.57 3.506-.002 1.929-1.623 3.501-3.598 3.494zm5.834 3.896c.45-.256.964-.393 1.492-.393a2.996 2.996 0 012.775 1.816 2.933 2.933 0 01-.742 3.325l-2.472 2.426a1.502 1.502 0 01-2.107 0l-2.405-2.365a2.938 2.938 0 01-.154-4.346 3.03 3.03 0 013.613-.463zm-2.125 3.32l2.125 2.086 2.191-2.145.023-.021a.935.935 0 00.212-1.036 1 1 0 00-.928-.597h-.005c-.269 0-.525.104-.712.287l-.02.022-.744.876-.765-.858-.034-.037-.006-.007a1.027 1.027 0 00-1.425.002.937.937 0 00-.002 1.348c.009.009.016.016.09.08zm-3.478 1.48h-7.86c-.01-.012-.028-.023-.028-.035-.002-.734-.02-1.469.001-2.203.02-.72.394-1.264.904-1.722.76-.681 1.666-1.087 2.608-1.415a13.122 13.122 0 014.1-.742c.56-.01 1.119.068 1.704.109-.266.378-.561.688-.728 1.061-.219.491-.521.606-1.031.605-1.733-.007-3.374.445-4.917 1.254-.188.098-.36.232-.536.354-.335.233-.485.549-.392.987h5.915l.26 1.747z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="PersonLove_svg__b" fill="#fff">
          <use xlinkHref="#PersonLove_svg__a" />
        </mask>
        <use fill="#000" xlinkHref="#PersonLove_svg__a" />
        <g fill="#091E42" mask="url(#PersonLove_svg__b)">
          <path d="M0 0h24v24H0z" />
        </g>
      </g>
    </svg>
  );
}

export default SvgPersonLove;
